


















import { Vue, Component, Model, Prop } from "vue-property-decorator";
import Site from "@/models/site";
import SitesAPI from "@/services/sites";
import { QueryParams } from "@/models/general";

@Component
export default class SiteSelector extends Vue {
  @Model("change") value?: string[] | string;
  @Prop({ default: "components.site_selector.label" }) label!: boolean;
  @Prop({ default: () => [] }) rules!: boolean[];
  @Prop({ default: true }) multiple!: boolean;
  @Prop({ default: false }) dense!: boolean;
  @Prop({ default: false }) clearable!: boolean;

  sites: Site[] = [];
  loading = true;

  created(): void {
    this.getSites();
  }

  async getSites(): Promise<void> {
    try {
      this.loading = true;
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };
      const r = await SitesAPI.getSites(params);
      this.sites = r.data.sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
}
